module.exports = __webpack_public_path__ + "img/audio.37503a1a.png";